module.exports = __webpack_public_path__ + "media/images/procedure_managements/examples/tasks_image-defd81e9b367e86f15ce690c5fb2acda.jpg";